export default defineNuxtPlugin(() => {
  const setRem = () => {
    const baseSize = 37.5 // 和 rootValue 保持一致
    const clientWidth = document.documentElement.clientWidth

    // PC端（宽度 > 750px）：固定使用 375px 对应的 fontSize
    // 移动端（宽度 <= 750px）：根据屏幕宽度自适应
    if (clientWidth > 750) {
      // PC端：固定 fontSize = 37.5px（对应 375px 设计稿）
      document.documentElement.style.fontSize = baseSize + 'px'
    } else {
      // 移动端：自适应，最大支持 750px
      const width = Math.min(clientWidth, 750)
      const scale = width / 375
      document.documentElement.style.fontSize = baseSize * scale + 'px'
    }
  }

  setRem()
  window.addEventListener('resize', setRem)
})
